interface Props<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: { value: T; label: string }[];
}

export const SegmentedControl = <T extends string>({
  value,
  onChange,
  options,
}: Props<T>) => {
  const selectedIndex = Math.max(
    0,
    options.findIndex((option) => option.value === value),
  );

  return (
    <div className="relative flex h-11 w-full rounded-lg border border-primary-200">
      <div
        className="absolute top-0 bottom-0 w-1/2 rounded-md bg-primary-50 transition-transform duration-300 ease-in-out"
        style={{
          width: `${100 / options.length}%`,
          transform: `translateX(${selectedIndex * 100}%)`,
        }}
      />

      {options.map((option) => (
        <button
          type="button"
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`relative z-10 flex-1 rounded-lg text-sm font-medium transition-colors duration-300 ${value === option.value ? "text-neutral-950" : "text-neutral-700"} `}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
